import { Component } from '@angular/core';
import { ApiContentComponentBase, ApiContentTypes } from './api-content-base.component';

@Component({
    selector: 'api-faq',
    templateUrl: './api-faq.template.html',
    standalone: false
})
export class ApiFaqComponent extends ApiContentComponentBase {
    fileUrl = 'Content/ApiDocumentation/faq.md';

    type = ApiContentTypes.markdown;
}